export enum QueryCondition {
	And,
	Or
}